import { useTranslation } from 'react-i18next';
import type { PricingMinimumStayCandidate, PricingMinimumStayExplanation } from '@/shared/api';

export function MinimumStayDecisionExplanation({
  explanation,
}: {
  explanation?: PricingMinimumStayExplanation | null;
}) {
  const { t } = useTranslation();
  if (!explanation || explanation.candidates.length === 0) return null;
  const selected = explanation.candidates.find((candidate) => candidate.selected);
  const discarded = explanation.candidates.filter((candidate) => !candidate.selected);
  return (
    <section className="border-line bg-card-alt mt-3 grid gap-1 rounded-md border p-3 text-sm">
      <h4 className="text-ink font-semibold">
        {t('admin.dynamicPricing.minimumStayExplanation.title')}
      </h4>
      {selected && <p className="text-ink">{label(selected, t)}</p>}
      {discarded.length > 0 && (
        <p className="text-ink-soft">
          {t('admin.dynamicPricing.minimumStayExplanation.discarded', {
            candidates: discarded.map((candidate) => label(candidate, t)).join(' · '),
          })}
        </p>
      )}
    </section>
  );
}

function label(candidate: PricingMinimumStayCandidate, t: ReturnType<typeof useTranslation>['t']) {
  const count = candidate.minimumStayNights;
  return candidate.code === 'lead_time_tier'
    ? t('admin.dynamicPricing.minimumStayExplanation.leadTimeTier', {
        days: candidate.daysBeforeArrival,
        count,
      })
    : t(`admin.dynamicPricing.minimumStayExplanation.${candidate.code}`, { count });
}
